import React, { useEffect, useState } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { useLocation } from "@reach/router";
import { pushtracking } from "../../../service/trackingService";

import "./css/personalized.css";

const Doihang=()=> {

    const [meta, setMeta] = useState([]);
    const location = useLocation();
    useEffect(() => {
        try{
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Quy định tích và tiêu bixu", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[])
    const handleClick=(uri)=>{
        window.location.href = uri;
    }
    const handleBack=()=>{
        window.history.back();
    }
  return (
    <Layout>
        {/* <h1 className='d-none'>Chính sách đổi hàng</h1> */}
        <div className="fixed">
            <div className="header1 filter">
                <div className="row mgx-0 pdy-10 pdx-0">
                    <div className="col-2 in-f">
                        <a onClick={handleBack}>
                            <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                        </a>
                    </div>
                    <div className="col-8 text-center">
                        <strong className="text_header  color_black">Chính sách đổi hàng</strong>
                    </div>
                    <div className="col-2"></div>
                </div>
            </div>  
        </div>
        <h1 className='d-none'>Chính sách đổi hàng</h1>
        <div className='container page-builder-ltr'>
          <div className='container-page-exchangepolicy'>
            <p><img className="w-100" lazy="" src="https://media.bibomart.net/image/2024-07-08_f6c5ae49-0322-49fb-8287-8d082501678d.jpg/origin" alt="chinh-sach-hoan-tien"/></p>
          </div>  
        </div>
    </Layout>
  )
}
export default Doihang;